<div class="modal-popup" mat-dialog-content>
    <h2 style="color: #0D87C8">Import</h2>
    <form>
        <!-- File Upload Section -->
        <div class="my-3">
            <!-- <mat-card class="upload-card p-4">
                <div *ngIf="!fileName" class="upload-area text-center" (click)="fileInput.click()">
                    <label class="d-flex justify-content-center align-items-center" for="upload" mat-raised-button>
                        <img alt="Add File" src="./../../assets/images/photo-add.svg" class="me-2" width="40">
                        <span>Select File</span>
                    </label>
                </div>
    
                <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;" accept=".csv">
    
                <div *ngIf="fileName" class="file-info d-flex justify-content-between align-items-center mt-3">
                    <span class="fw-bold">{{ fileName }}</span>
                    <button mat-icon-button color="warn" (click)="removeFile()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-card> -->
    
            <!-- Error Message for Invalid File Type -->
            <mat-error class="text-danger mt-2 d-flex align-items-center" *ngIf="invalidFileType">
                <img class="me-2" loading="lazy" alt="Error" src="./../../assets/images/alert.svg" width="20"/> 
                Invalid file type {{fileType}}. Only CSV files are allowed.
            </mat-error>
        </div>
    
        <!-- Download Sample CSV Section -->
        <!-- <a class="btn btn-outline-primary d-flex align-items-center mt-3 download-file" (click)="downloadCSVFile()">
            <img src="assets/images/download.svg" alt="Download CSV" class="me-2" width="20">
            Sample CSV for Download
        </a> -->

        <!-- <a class="btn btn-outline-primary d-flex align-items-center mt-3 download-file" (click)="downloadUserFile()">
            <img src="assets/images/download.svg" alt="Download CSV" class="me-2" width="20">
            Download User Data
        </a> -->
        <a class="btn btn-outline-primary d-flex align-items-center mt-3 download-file" (click)="downloadTemplate()">
            <img src="assets/images/download.svg" alt=""> Download Template
        </a>
        
    
        <!-- Info Section with Product Category IDs -->
        <!-- <div class="my-4" style="cursor: pointer;">
            <div class="btn btn-outline-primary alert-info d-flex justify-content-between align-items-center download-file" style="padding: 11px;" (click)="downloadCategoryCSVFile ()">
                <img src="assets/images/download.svg" alt="Download Icon" class="me-2" style="margin-left: 2px; margin-top: -3px;" width="20"><p class="mb-0" style="position: absolute; left: 65px;">Please refer to this sheet for the Product Category IDs</p>
            </div>
        </div> -->
    
        <!-- Popup Buttons -->
        <div class="popup-buttons text-center mt-4">
            <button mat-raised-button class="btn btn-danger me-2" [mat-dialog-close]="false" type="button">Close</button>
        </div>
    </form>
    
</div>



